import { useEffect, useState } from 'react';
import { Code2, Copy, Download } from 'lucide-react';
import { useI18n } from '../i18n/LanguageContext';
const defaultFiles = ['platformio.ini', 'src/main.cpp', 'README.md'];
export default function KitSource({ kitId, files = defaultFiles, label = 'Original supplied firmware' }: { kitId: string; files?: string[]; label?: string }) {
  const { t } = useI18n();
  const base = `${process.env.PUBLIC_URL}/downloads/${kitId}/`;
  const [file, setFile] = useState(files[0]);
  const [source, setSource] = useState('');
  const [status, setStatus] = useState('Loading source…');
  const [copyStatus, setCopyStatus] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setSource(''); setStatus('Loading source…'); setCopyStatus('');
    fetch(base + file, { signal: controller.signal }).then(async response => {
      if (!response.ok || response.headers.get('content-type')?.includes('text/html')) throw new Error('Source unavailable');
      return response.text();
    }).then(text => { if (!controller.signal.aborted) { setSource(text); setStatus(''); } })
      .catch(() => { if (!controller.signal.aborted) setStatus('Unable to load source. Please try again.'); });
    return () => controller.abort();
  }, [base, file, retry]);
  const copy = async () => {
    try { await navigator.clipboard.writeText(source); setCopyStatus('Copied'); }
    catch { setCopyStatus('Copy unavailable. Download the file instead.'); }
  };
  return <section className="trackerSource"><div className="trackerSourceHeading"><Code2 size={20}/><h2>{t('Source files')}</h2><span>{t(label)}</span></div>
      <div className="trackerFileBar"><div className="trackerFileButtons" aria-label={t('Source files')}>{files.map(name => <button key={name} aria-pressed={file === name} onClick={() => setFile(name)}>{name}</button>)}</div><div className="trackerFileActions"><button onClick={copy} disabled={!source}><Copy size={15}/>{t('Copy code')}</button><a href={base + file} download={file.split('/').pop()}><Download size={15}/>{t('Download file')}</a></div></div>
      {status ? <div className="trackerLoad" role="status">{t(status)}{status !== 'Loading source…' && <button className="textLink" onClick={() => setRetry(value => value + 1)}>{t('Try again')}</button>}</div> : <pre tabIndex={0} aria-label={file}><code>{source}</code></pre>}
      <div className="trackerSourceFooter"><span>{kitId} / {file}</span><span role="status">{t(copyStatus)}</span></div>
    </section>;
}
